import type { getOnValue as getOnValueType } from './firebase';

const WAIT = 7000;
const delay = <T>(fn: () => Promise<T>, t: number) => new Promise<T>(r => setTimeout(() => r(fn()), t));

type GetOnValue = typeof getOnValueType;

let getOnValuePromise: Promise<GetOnValue> | undefined;

export const getOnValue: GetOnValue = async path => {
    if (!getOnValuePromise) {
        getOnValuePromise = delay(() => import(/* webpackChunkName: 'Firebase' */ './firebase'), WAIT).then(
            firebase => firebase.getOnValue
        );
    }
    return (await getOnValuePromise)(path);
};
